export default __webpack_public_path__ + "static/media/GraficoIconWhite.7c582bcc.svg";